export default __webpack_public_path__ + "static/media/WGP_text.8b4bce75.png";